export default "__VITE_ASSET__462f8a9b__$_?component__"